import { SaveFeedbackPrompt } from "../../../types/gqlTypes/graphql"
import { SAVE_FEEDBACK_RESPONSE } from "./feedbackMutations"
import { retry } from "../helpers/studyPlan/studyPlanApolloStatic"
import { executeMutationSideload } from "../helpers/studyPlan"

export async function saveFeedbackResponse(
  data: SaveFeedbackPrompt
): Promise<boolean> {
  const response = await retry(
    () =>
      executeMutationSideload(SAVE_FEEDBACK_RESPONSE, {
        data
      }),
    3,
    1000
  )

  return response?.feedback?.saveFeedbackResponse
}
